module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc1-88a16a7c7d48ef4a9db760fe6347740a.jpg";